import { React, useState} from 'react';
import {Box,Text,useDisclosure,Flex,Button} from '@chakra-ui/react';
import SimpleSidebar from "views/global/SimpleSidebar";
import BoxDataTable from "views/global/BoxDataTable";
import SidebarScroll from 'components/scroll/SidebarScroll';
import { QuickAlert } from "theme/components/alerts";
import { Trash2, Pencil, List, Laptop, Users, User, ClipboardList, Calendar, PauseCircle, CheckCircle2, XCircle, Building, BedDouble, Send, PlusCircle, MinusCircle } from "lucide-react";
import handleSidebar from "lib/handleSidebar";
import { userController } from 'lib/user';
import FormGenerate from "views/global/FormGenerate";
import handleConfirmation from 'lib/handleConfirmation';
import BeatLoader from "react-spinners/BeatLoader";
import { departmentLabels, taskStatusLabels, reservationStatusLabels, notificationStatusLabels, notificationTypeLabel, toOptions, labelFor } from 'lib/labels';


function ReservationTab(props) {

    const { id, title } = props;

    const { setAlert, clearAlert, showAlert } = QuickAlert();
    const {saveRecord, getSingleRecord, userDetail, deleteRecord} = userController();
    const [notifications, setNotifications] = useState([]);
    const [tasksExpanded, setTasksExpanded] = useState(true);
    const [notifExpanded, setNotifExpanded] = useState(false);

    const [input, setInput] = useState(id ? {property_id: id} : null);

    const [status, setStatus] = useState({
        sidebarForm: false,
        loading: false,
        formLoading: false,
        saveNewList: false,
        editListEnabled: false,
        viewListEnabled: false,
        reservationTitle: "",
    });
    const trigerSaveList = status.saveNewList ? false : true;


    const fieldNames          = []
    if(!id){
        fieldNames.push({label:"Seleziona proprietà", name:"property_id", type:"dynamic-select", dynamic_label:"identifier", required: true, src:"/user/dynamic/list/properties", placeholder:"nome proprietà"});
    }
    fieldNames.push(...[
        {label: "Nome", name:"name", type:"text", required: true},
        {label: "Email", name:"email", type:"email", required: false},
        {label: "Telefono", name:"number", type:"text", required: false},
        {label: "Check-In", name:"check_in", type:"datetime-local", required: true},
        {label: "Check-Out", name:"check_out", type:"datetime-local", required: true},
        {label: "Note", name:"notes", type:"textarea", required: false},
        {label: "Richieste Particolari", name:"special_request", type:"textarea", required: false},
        {label: "Adulti", name:"adults", type:"select", required: false, options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]},
        {label: "Bambini", name:"children", type:"select", required: false, options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]},
        {label: "Canale", name:"channel", type:"select", required: false, options: ['Airbnb', 'Booking']},
        {label: "ID Canale", name:"channel_reservation_id", type:"text", required: false},
        {label: "Riferimento", name:"ref", type:"text", required: false},
        {label: "Agenzia", name:"agency", type:"text", required: false},
        {label: "Importo Totale", name:"total_amount", type:"text", required: false},
        {label: "Importo Annullamento", name:"cancellation_amount", type:"text", required: false},
        {label: "Commissione", name:"commission", type:"text", required: false},
        {label: "Extra", name:"extra", type:"text", required: false},
        {label: "Cauzione", name:"deposit", type:"text", required: false},
        {label: "Stato", name:"status", type:"select", required: false, options: toOptions(reservationStatusLabels)},
        {type: "divider"},
        {label: "Importo Tassa di Soggiorno", name:"city_tax__amount", type:"text", required: false, split: true},

    ]);


    const checkboxMenu = [
        {
            icon: <Trash2 />,
            name: "Elimina",
            color: "red",
            handle : (checked) => handleConfirmation(checked, "delete", {one: "la prenotazione selezionata", many: "le prenotazioni selezionate"}, "Questa azione non può essere annullata.", "/user/reservation/delete",(response) => {
                clearAlert();
                setStatus(prevStatus => ({
                    ...prevStatus,
                    saveNewList: trigerSaveList,
                }));
                setAlert(response.data.status, response.data.message);
            },
            (error) => {
                setAlert("error",error.response.data.errors);
            }),
        }
    ];
    const tableMenuItems = [
        {
            icon: <Pencil />,
            title: "Modifica Prenotazione",
            handle : (row) => {
                setStatus(prevStatus => ({
                    ...prevStatus,
                    sidebarForm: true,
                    editListEnabled: true,
                    viewListEnabled: false,
                    formLoading: false
                }));
                setInput((prev) => ({
                    ...prev,
                    ...row,
                }));
                handleSidebar();
            },
        },
    ];

    const buttons = [
        {
            title: "Aggiungi Prenotazione",
            variant: "outline",
            color: "brand",
            icon: <List />,
            handle: () => {
                setStatus(prevStatus => ({
                    ...prevStatus,
                    sidebarForm: true,
                    editListEnabled: false,
                    viewListEnabled: false,
                }));
                setInput(id ? {property_id: id} : null);
                handleSidebar();


            }
        },
    ];

    const hideList = () => {
        setStatus(prevStatus => ({
            ...prevStatus,
            sidebarForm: false,
            editListEnabled: false,
            viewListEnabled: false,
            reservationTitle: "",
        }));
        setInput(id ? {property_id: id} : null);
        setNotifications([]);
        handleSidebar(false);
        clearAlert();
    }

    const loadNotificationHistory = (reservationId) => {
        getSingleRecord('/user/reservation/notification/list?reservation_id=' + reservationId)
            .then(response => {
                setNotifications(response.data.rows || []);
            })
            .catch(() => {
                setNotifications([]);
            });
    }

    const saveListHandle = () => {
        setStatus(prevStatus => ({
            ...prevStatus,
            loading: true,
        }));
        saveRecord('/user/reservation/create',input).then(response => {
            return response;
        }).then(response => {
            setStatus(prevStatus => ({
                ...prevStatus,
                loading: false,
                saveNewList: trigerSaveList,
            }));
            hideList();
        }).catch(function(error) {
            setStatus(prevStatus => ({
                ...prevStatus,
                loading: false,
            }));
            setAlert("error",error.response.data.errors);
            SidebarScroll();
        });
    }

    return (
        <>
        <Box>
            {status.sidebarForm===false ? showAlert() : null }
            <BoxDataTable
                title={title}
                buttons={buttons}
                src="/user/reservation/list"
                additionalOptions={id ? {property_id: id} : null}
                search={true}
                checkbox={id ? true : false}
                checkboxMenu={checkboxMenu}
                tableMenu={tableMenuItems}
                trigger={status.saveNewList}
                design="dragable"
                dragableType="Reservation"
                defaultCalander="created_at"
                tableContent={(item)=>{
                    return (
                        <Box
                        cursor={"pointer"}
                        onClick={() => {
                            setStatus(prevStatus => ({
                                ...prevStatus,
                                sidebarForm: true,
                                viewListEnabled: true,
                                reservationTitle: item.name,
                                formLoading: false
                            }));
                            setInput((prev) => ({
                                ...prev,
                                ...item,
                            }));
                            setNotifications([]);
                            setTasksExpanded(true);
                            setNotifExpanded(false);
                            clearAlert();
                            loadNotificationHistory(item.id);
                            handleSidebar();
                        }}
                        >
                            <Flex
                            alignItems={"center"}
                            >
                                {item.pending_tasks > 0 && ( <Text className="circle-pending" me={4}> {item.pending_tasks}</Text> )}
                                {item.completed_tasks > 0 && ( <Text className="circle-completed" me={4}> {item.completed_tasks}</Text> )}
                                <Text className={item.status+" reservation-item-title"}>{item.name}</Text>
                            </Flex>
                            
                            <Flex
                            display={{base:"block", md:"flex"}}
                            >
                                <Text className="muted-text d-flex d-icon-5" me={4}> <Calendar/> {item.check_in} - {item.check_out}</Text>
                                <Text className="muted-text d-flex d-icon-5 d-icon-fx-18" me={4}><Users/> {item.adults}</Text>
                                <Text className="muted-text d-flex d-icon-5" me={4}><Laptop/> {item.channel}</Text>
                                <Text className="muted-text d-flex d-icon-5 d-icon-fx-18"><Building/> {item.property.identifier}</Text>
                                {item.property_room && 
                                    <Text className="muted-text d-flex d-icon-5 d-icon-fx-18" ms={4}><BedDouble/> {item.property_room.description}
                                </Text>}
                            </Flex>
                        </Box>
                    )
                }}
            />
            <SimpleSidebar
            status={status.sidebarForm}
            title={status.viewListEnabled ? status.reservationTitle : (status.editListEnabled ? "Modifica Prenotazione" : "Aggiungi Prenotazione")}
            save={{onClick:saveListHandle,isLoading:status.loading,text:status.editListEnabled ? "Aggiorna Prenotazione" : "Aggiungi Prenotazione"}}
            cancel={{onClick:hideList, text:"Annulla"}}
            loading={status.formLoading}
            viewOnly={status.viewListEnabled}
            >
                {status.sidebarForm===false ?  null : showAlert() }
                {status.sidebarForm===true && !status.viewListEnabled &&
                    <FormGenerate fields={fieldNames} setFields={setInput} defaultValue={input ? input : []} />
                }
                {status.sidebarForm===true && status.viewListEnabled && input &&
                    <>
                    <Box
                    p={4}
                    borderRadius="md"
                    mb={4}
                    border={"1px solid"}
                    borderColor={"gray.200"}
                    >
                        <Box
                        mb={4}
                        className='task-header-meta'
                        display={{base:"block", md:"flex"}}
                        justifyContent={{base:"center", md:"space-between"}}
                        alignItems={{base:"center", md:"center"}}
                        >
                            {input.check_in && input.check_out &&
                            <Text className='task-header-created-date task-header-item'>
                                <Calendar/>
                                {input.check_in} - {input.check_out}
                            </Text>
                            }
                            {input.channel &&
                            <Text className='task-header-created-date task-header-item'>
                                <Laptop/>
                                {input.channel}
                            </Text>
                            }
                            {input.status &&
                            <Text className={input.status+ ' task-header-status task-header-item'}>
                                {input.status==="confirmed" || input.status==="checked-in" ? <CheckCircle2/> : (input.status=="pending" ? <PauseCircle/> : <XCircle/>)}
                                {labelFor(reservationStatusLabels, input.status)}
                            </Text>
                            }
                        </Box>
                        <Box
                        className='task-header-meta'
                        display={{base:"block", md:"flex"}}
                        alignItems={{base:"center", md:"center"}}
                        gap={4}
                        >
                            {input.property.identifier &&
                            <Text className='task-header-created-date task-header-item'>
                                <Building/>
                                {input.property.identifier}
                            </Text>
                            }
                            {input.property_room &&
                            <Text className='task-header-created-date task-header-item'>
                                <BedDouble/>
                                {input.property_room.description}
                            </Text>
                            }
                            {input.adults &&
                            <Text className='task-header-created-date task-header-item'>
                                <Users/>
                                {input.adults+input.children}
                            </Text>
                            }
                        </Box>
                    </Box>
                    <Box
                    className='reservation-details'
                    display={{base:"block", md:"flex"}}
                    mb={2}
                    >
                        <Text width={{base:"100%", md:"50%"}}><span>Email Ospite</span> {input.email ? input.email : "-"}</Text>
                        <Text><span>Telefono Ospite</span> {input.number ? input.number : "-"}</Text>
                    </Box>
                    <Box
                    className='reservation-details'
                    display={{base:"block", md:"flex"}}
                    mb={2}
                    >
                        <Text width={{base:"100%", md:"50%"}}><span>ID Prenotazione</span> {input.id ? input.id : "-"}</Text>
                        <Text><span>Riferimento</span> {input.ref ? input.ref : "-"}</Text>
                    </Box>
                    <Box
                    className='reservation-details'
                    display={{base:"block", md:"flex"}}
                    >
                        <Text width={{base:"100%", md:"50%"}}><span>Notti</span> {input.total_nights ? input.total_nights : "-"}</Text>
                        <Text><span>Agenzia</span> {input.agency ? input.agency : "-"}</Text>
                    </Box>
                    <Box
                    className='reservation-details'
                    display={{base:"block", md:"flex"}}
                    >
                        <Text width={{base:"100%", md:"50%"}}><span>Importo Totale</span> {input.total_amount ?  input.total_amount + " EUR" : "-"}</Text>
                        <Text width={{base:"100%", md:"50%"}}><span>Commissione</span> {input.commission ?  input.commission + " EUR" : "-"}</Text>
                    </Box>
                    {/* La penale trattenuta: è questa — non l'importo totale — a
                        contare come ricavo per una prenotazione annullata. */}
                    {(input.status === "cancelled" || input.cancellation_amount) &&
                    <Box
                    className='reservation-details'
                    display={{base:"block", md:"flex"}}
                    >
                        <Text width={{base:"100%", md:"50%"}}><span>Importo Annullamento</span> {input.cancellation_amount ?  input.cancellation_amount + " EUR" : "-"}</Text>
                    </Box>
                    }
                    <Box
                    className='reservation-details'
                    display={{base:"block", md:"flex"}}
                    >
                        <Text width={{base:"100%", md:"50%"}}><span>Importo Tassa di Soggiorno</span> {input.city_tax && input.city_tax.amount ?  input.city_tax.amount + " " +input.city_tax.currency : "-"}</Text>
                        <Text width={{base:"100%", md:"50%"}}><span>Link Tassa di Soggiorno</span> {input.city_tax && input.city_tax.link && <a target='_blank' className='primary-link' href={input.city_tax.link}>{(() => {
                            const cleanedLink = input.city_tax.link.replace(/^https?:\/\/(www\.)?/, '');
                            return cleanedLink.length > 25 ? `${cleanedLink.substring(0, 25)}...` : cleanedLink;
                        })()}</a>}</Text>
                    </Box>
                    {(() => {
                        const appSettings = JSON.parse(localStorage.getItem("app_settings") || "{}");
                        if (appSettings.documents_enabled === false) return null;
                        const gcl = input.guest_collection_link;
                        if (!gcl) return null;
                        const docUrl = process.env.REACT_APP_URL + '/document/request/' + gcl.unique_token;
                        return (
                            <Box className='reservation-details' display={{base:"block", md:"flex"}}>
                                <Text width={{base:"100%", md:"50%"}}><span>Link Documenti</span> <a target='_blank' className='primary-link' href={docUrl}>{(() => {
                                    const cleaned = docUrl.replace(/^https?:\/\/(www\.)?/, '');
                                    return cleaned.length > 25 ? `${cleaned.substring(0, 25)}...` : cleaned;
                                })()}</a></Text>
                                <Text width={{base:"100%", md:"50%"}}><span>Password Documenti</span> {gcl.pin}</Text>
                            </Box>
                        );
                    })()}
                    
                    <Box
                    className='reservation-details'
                    >
                        {input.notes && <Text><span>Note</span> {input.notes}</Text>}
                    </Box>
                    <Box
                    className='reservation-details'
                    >
                        {input.special_request && <Text><span>Richieste Particolari</span> {input.special_request}</Text>}
                    </Box>
                    {input.tasks &&
                    <Box className='reservation-tasks-list' marginBottom={4}>
                        <Flex className="rtl-title" justify="space-between" align="center" cursor="pointer" onClick={() => setTasksExpanded(p => !p)}>
                            <span>Attività</span>
                            {tasksExpanded ? <MinusCircle/> : <PlusCircle/>}
                        </Flex>
                        {tasksExpanded &&
                        <ul>
                            {input.tasks.map((task, index) => (
                                <li key={"task_"+index}>
                                    {task.title && (<Text className='rtl-task-title'>{task.title}</Text>)}
                                    <Flex className='task-meta'>
                                        {task.due_date && (<Text className="muted-text d-flex d-icon-5" me={4}><Calendar/> {task.due_date}</Text>)}
                                        {task.assignee && (
                                            <Text className="muted-text d-flex d-icon-5 d-icon-fx-18" me={4}><User/> {task.assignee.name}</Text>
                                        )}
                                        {task.department && (
                                            <Text className="muted-text d-flex d-icon-5 d-icon-fx-18 text-capitalize" me={4}><ClipboardList/> {labelFor(departmentLabels, task.department)}</Text>
                                        )}
                                        {task.status && (
                                            <Text className={task.status+ ' task-header-status task-header-item'}>
                                                {task.status==="completed" ? <CheckCircle2/> : <PauseCircle/>}
                                                {task.status==="completed" ? task.completed_at : labelFor(taskStatusLabels, task.status)}
                                            </Text>
                                        )}
                                    </Flex>
                                    {task.description && (<Text>{task.description}</Text>)}
                                </li>
                            ))}
                        </ul>
                        }
                    </Box>
                    }
                    <Box className='reservation-tasks-list' marginBottom={4}>
                        <Flex className="rtl-title" justify="space-between" align="center" cursor="pointer" onClick={() => setNotifExpanded(p => !p)}>
                            <span>Storico Notifiche</span>
                            {notifExpanded ? <MinusCircle/> : <PlusCircle/>}
                        </Flex>
                        {notifExpanded && (
                            notifications.length === 0 ? (
                                <Text className="muted-text">Nessuna notifica inviata.</Text>
                            ) : (
                                <ul>
                                    {notifications.map((n, i) => (
                                        <li key={"notif_"+i}>
                                            <Text className='rtl-task-title'>{notificationTypeLabel(n.type)}</Text>
                                            <Flex className='task-meta'>
                                                <Text className="muted-text d-flex d-icon-5 d-icon-fx-18" me={4}><Send/> {n.recipient}</Text>
                                                <Text className={"muted-text d-flex d-icon-5 d-icon-fx-18 " + n.status} textTransform="capitalize" me={4}>{labelFor(notificationStatusLabels, n.status)}</Text>
                                                <Text className="muted-text d-flex d-icon-5" me={4}><Calendar/> {n.sent_at}</Text>
                                            </Flex>
                                        </li>
                                    ))}
                                </ul>
                            )
                        )}
                    </Box>
                    </>
                }
            </SimpleSidebar>
        </Box>
        </>

    );
}
export default ReservationTab;
